<div class="plan-feature">
    <div class="plan-feature-description">
        <h4 class="plan-feature-header" *ngIf="header">{{header}}</h4>
        <p class="plan-feature-subheader" *ngIf="subheader">{{subheader}}</p>
    </div>
</div>
